import { toHHMMSS } from '@ninjacart/nc-nk-store';
import { Text, View, useTheme } from '@ninjacart/nc-nk-ui';
import React, { memo, useRef, useState } from 'react';
import { Slider } from 'react-native-awesome-slider';
import { SharedValue } from 'react-native-reanimated';

interface IVideoSliderMemoProps {
  progressProp: SharedValue<number>;
  minProp: SharedValue<number>;
  maxProp: SharedValue<number>;
  currentTime?: SharedValue<string>;
  onVideoSlidingComplete?: (value: number) => void;
  remainingTime: number;
  duration: number;
  thumbScaleValue: SharedValue<number>;
  isScrubbing: SharedValue<boolean>;
}

const AutoPlayVideoSlider = memo(
  ({
    progressProp,
    minProp,
    maxProp,
    remainingTime,
    onVideoSlidingComplete,

    // remainingTime,
    duration,
    thumbScaleValue,
    isScrubbing,
  }: IVideoSliderMemoProps) => {
    // const thumbScaleValue = useSharedValue(1);
    // const isScrubbing = useRef(false);
    const theme = useTheme();

    // if (progressProp.value > 5 && thumbScaleValue.value !== 0) {
    //   console.log('progressProp.value', progressProp.value);
    //   thumbScaleValue.value = 0;
    // }

    const onSlidingComplete = (value: number) => {
      isScrubbing.value = false;
      onVideoSlidingComplete?.(value);
      thumbScaleValue.value = 0;
    };

    const onSlidingStart = () => {
      // if (isScrubbing.current) return;
      isScrubbing.value = true;
      console.log('Is scrubbing!!!');
      thumbScaleValue.value = 1;
    };

    const formatTime = (seconds: number) => {
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      return `${hrs > 0 ? `${hrs}:` : ''}${hrs > 0 && mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const formatTimeOnPlay = () => {
      const progressed = duration - progressProp.value;
      console.log('Progressed => ', progressed);
      if (progressed <= 0) {
        const durationFormatted = toHHMMSS(progressed);
        return durationFormatted;
      }

      return `00:00`;
    };

    const renderBubble = () => {
      return null;
      // const bubbleText = formatTime(progressProp.value);
      // return (
      //   <View
      //     width={'40%'}
      //     padding={4}
      //     alignItems={'center'}
      //     backgroundColor="rgba(0, 0, 0, 0.5)"
      //     borderRadius={4}
      //   >
      //     <Text fontSize={12} color="#fff">
      //       {bubbleText}
      //     </Text>
      //   </View>
      // );
    };

    return (
      <>
        <Slider
          progress={progressProp}
          minimumValue={minProp}
          maximumValue={maxProp}
          sliderHeight={3}
          onSlidingComplete={onSlidingComplete}
          onSlidingStart={onSlidingStart}
          renderBubble={renderBubble}
          theme={{
            disableMinTrackTintColor: theme['seekBarColor']?.val,
            minimumTrackTintColor: theme['seekBarColor']?.val,
            maximumTrackTintColor: 'rgba(0, 0, 0, 1)',
            cacheTrackTintColor: '#999',
            bubbleBackgroundColor: '#666',
            heartbeatColor: '#999',
          }}
          panHitSlop={{ top: 48, bottom: 24, right: 24, left: 24 }}
          thumbScaleValue={thumbScaleValue}
        />
        <Text
          style={{
            position: 'absolute',
            bottom: 20,
            right: 16,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: 4,
            padding: 4,
            color: '#fff',
            fontSize: 12,
          }}
        >
          {toHHMMSS(remainingTime) ?? `00:00`}
        </Text>
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.progressProp === nextProps.progressProp &&
      prevProps.remainingTime === nextProps.remainingTime
    );
  }
);

export default AutoPlayVideoSlider;
